export const validateUniversity = (name) => {
  const value = name.trim();

  if (!value) return "University name is required";

  // Allow letters (all languages), numbers, spaces, dots, hyphens
  if (!/^[\p{L}0-9\s.-]{2,100}$/u.test(value)) {
    return "Invalid characters in university name";
  }

  // Block repeated same letters like "aaaaaaa"
  if (/^([\p{L}])\1+$/u.test(value)) {
    return "Invalid university name";
  }

  return null; // ✅ valid
};


export const validateResearchAreas = (research_areas) => {
  if (!research_areas || !research_areas.trim()) {
    alert("Please enter at least one research area.");
    return false;
  }

  // Split comma-separated input
  const areas = research_areas
    .split(',')
    .map(a => a.trim())
    .filter(a => a);

  // 1️⃣ Max 5 areas
  if (areas.length > 5) {
    alert("You can enter a maximum of 5 research areas only.");
    return false;
  }

  // Regex: letters (Unicode), numbers, spaces, hyphens
  const areaRegex = /^[\p{L}0-9\s-]{1,200}$/u;

  // 2️⃣ Check each area
  for (let area of areas) {
    if (area.length > 200) {
      alert(`Research area "${area}" exceeds 200 characters.`);
      return false;
    }

    if (!areaRegex.test(area)) {
      alert(`Research area "${area}" contains invalid characters. Only letters, numbers, spaces, and hyphens are allowed.`);
      return false;
    }
  }

  // ✅ All checks passed
  return true;
};


const validateShortBio = (bio) => {
  if (!bio || !bio.trim()) {
    alert("Please enter a short bio.");
    return false;
  }

  // Max 300 characters
  if (bio.length > 300) {
    alert("Short Bio cannot exceed 300 characters.");
    return false;
  }

  // Only letters (Unicode), numbers, spaces, and basic punctuation
  const bioRegex = /^[\p{L}0-9\s.,;:!?'"()-]{1,300}$/u;
  if (!bioRegex.test(bio)) {
    alert("Short Bio contains invalid characters. Only letters, numbers, spaces, and basic punctuation are allowed.");
    return false;
  }

  // Block excessive repeated letters (>3)
  if (/([\p{L}])\1{3,}/u.test(bio)) {
    alert("Short Bio contains excessive repeated letters.");
    return false;
  }

  // ✅ All validations passed
  return true;
};


const regex = /^[a-zA-Z0-9\s.+#-]+$/;

function validateSkill(skill) {
  return regex.test(skill);
}

console.log(validateSkill("ReactJS")); // true
console.log(validateSkill("<script>alert('hello')</script>")); // false